/* eslint-env jquery */

"use strict";

const initTwitchAPI = () => {
    let currentScriptTag = document.getElementById("vimeo-iframe-api");

    if (!currentScriptTag) {
        var tag = document.createElement("script"),
            firstScriptTag = document.getElementsByTagName("script")[0];

        tag.id = "vimeo-iframe-api";
        tag.src = "https://player.vimeo.com/api/player.js";
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
};

const startVideo = ($videoPlayer, videoId, isLoop, autoPlay, isMuted) => {
    let playerTag = $videoPlayer[0].querySelector(".video-player");

    try {
        var options = {
            id: videoId,
            height: playerTag.clientHeight,
            width: playerTag.clientWidth,
            loop: isLoop,
            autoplay: autoPlay,
            mute: isMuted,
            autopause: true
        };

        var videoPlayer = new window.Vimeo.Player(playerTag, options);
        videoPlayer.play();

        return true;
    } catch {
        return false;
    }
};

const initPlayer = ($videoPlayer) => {
    const videoId = $videoPlayer.data("video-id");
    const isLoop = $videoPlayer.data("video-loop");
    const autoPlay = $videoPlayer.data("video-auto-play");
    const isMuted = $videoPlayer.data("video-muted");

    if (!$videoPlayer.hasClass("player-initialized")) {
        initTwitchAPI();

        setTimeout(() => {
            const videoStarted = startVideo($videoPlayer, videoId, isLoop, autoPlay, isMuted);
            if (!videoStarted) {
                initPlayer($videoPlayer);
                return;
            }
            $videoPlayer.addClass("player-initialized");
        }, 1000);
    }
};

(function () {
    $(".video-vimeo").each((index, player) => {
        const $videoPlayer = $(player);
        const isAutoplay = $videoPlayer.data("video-auto-play");

        if (isAutoplay) {
            initPlayer($videoPlayer);
        }
    });

    $(".video-vimeo").on("click", function (ev) {
        const $videoPlayer = $(ev.target).parents(".video-vimeo");
        initPlayer($videoPlayer);
    });
})();
